import "./bootstrapParticipant.js"

angular.module("ResearchKitStudioModule", ['CareEvWidgets', 'ngSanitize', 'ResearchKitApplicationModule', 'pascalprecht.translate']);

$(document).ready(function () {
    angular.bootstrap($(".rkstudio-layout"), ["ResearchKitStudioModule"]);

    var viewportTag = document.createElement("meta");
    viewportTag.name = 'viewport'
    viewportTag.content = 'width=device-width, initial-scale=1, maximum-scale=1'
    document.getElementsByTagName('head')[0].appendChild(viewportTag);
});